import React, { Component } from "react";
import Header from "../../Component/Header/HeaderOperation";
import HeaderAdmin from "../../Component/Header/HeaderAdmin";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Dash from "../../Views/Dash";
import Report from "../../Views/Report";
import Operation from "../../Views/Operation";
import Salidas from "../../Views/Salidas";
import Ingresos from "../../Views/Ingresos";
import Stock from "../../Views/Stock";
import PageAdmin from "./PageAdmin";

import { Switch, Redirect, Route } from "react-router-dom";

class PageOperation extends Component {
  constructor() {
    super();
    this.state = {
      nameHeader: null
    };
  }
  async componentDidMount() {
    const arrayRef = window.location.href;
    if (arrayRef.indexOf("Admin") > -1) {
      await this.setState({
        nameHeader: "Admin"
      });
    } else {
      await this.setState({
        nameHeader: null
      });
    }
  }
  async componentWillReceiveProps() {
    const arrayRef = window.location.href;
    if (arrayRef.indexOf("Admin") > -1) {
      await this.setState({
        nameHeader: "Admin"
      });
    } else {
      await this.setState({
        nameHeader: null
      });
    }
  }
  render() {
    const userType = localStorage.getItem("type");
    const isType6 = userType === "6";
    const currentPath = window.location.pathname;
    
    // Don't redirect if already on the correct path
    const shouldRedirect = !(
      (userType === "6" && currentPath.includes("/Admin")) ||
      (userType === "4" && currentPath.includes("/Salidas")) ||
      (userType !== "4" && userType !== "6" && currentPath.includes("/Operation"))
    );
    
    return (
      <div>
        <div className="page-admin">
          {this.state.nameHeader === "Admin" ? (
            <HeaderAdmin history={this.props.history} />
          ) : (
            <Header history={this.props.history} />
          )}
          <Sidebar
            open={this.props.open}
            handleChange={this.props.handleChange}
          />
          <Switch>
            {!isType6 && <Route path="/Main-Sesion/Operation" component={Operation} />}
            {!isType6 && <Route path="/Main-Sesion/Ingresos" component={Ingresos} />}
            {!isType6 && <Route path="/Main-Sesion/Salidas" component={Salidas} />}
            {!isType6 && <Route path="/Main-Sesion/Stock" component={Stock} />}
            {!isType6 && <Route path="/Main-Sesion/Report" component={Report} />}
            {!isType6 && <Route path="/Main-Sesion/Dashboard" component={Dash} />}
            <Route path="/Main-Sesion/Admin" component={PageAdmin} />

            {shouldRedirect && (
              <Redirect
                to={
                  userType === "6" 
                    ? "/Main-Sesion/Admin/Gerencia"
                    : userType === "4"
                    ? "/Main-Sesion/Salidas"
                    : "/Main-Sesion/Operation"
                }
              />
            )}
          </Switch>
        </div>
      </div>
    );
  }
}

export default PageOperation;
